module.exports = new __parcel__URL__("alertCheckIcon.242db0a0.svg").toString();